import {analyticsLogEvent} from '../api'
import type {ShareSocialName, WishlistShareSocialAction} from '_types'

const eventName = 'social'

interface EventParameters {
    socialNetwork: ShareSocialName
    socialAction: WishlistShareSocialAction
    socialTarget: string
}

/**
 * @name analyticsEventWishlistShare
 *
 * @event
 *
 * @description
 * Tracks users who click on share wishlist buttons.
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {ShareSocialName} params.socialNetwork - Social network about share click of the event (e.g., "facebook")
 * @param {WishlistShareSocialAction} params.socialAction - Action performed (e.g., "share").
 * @param {string} params.socialTarget - Specified target (URL of the shared wishlist).
 */
export function analyticsEventWishlistShare({socialNetwork, socialAction, socialTarget}: EventParameters) {
    const eventParams = {socialNetwork, socialAction, socialTarget}

    analyticsLogEvent(eventName, eventParams)
}
